import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type { AssetsByAreaHeirachy } from './assetsByAreaHierarchy.types';

export const assetsByAreaHeirachyPullQueryBuilder = (document: AssetsByAreaHeirachy) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(
    gql`
      query assetsByAreaHeirachyInfo($site: Int!, $discipline: Int!, $lastRequested: DateTime!) {
        assetsByAreaHeirachyInfo(
          site: $site
          discipline: $discipline
          lastRequested: $lastRequested
        ) {
          id
          name
          type
          isActive
          floorLevel
          siteId
          disciplineId
          trafficSafety
          areaPcsId
          dateModified
          children {
            id
            name
            type
            isActive
            floorLevel
            siteId
            disciplineId
            trafficSafety
            areaPcsId
            dateModified
            children {
              id
              name
              type
              isActive
              floorLevel
              siteId
              disciplineId
              trafficSafety
              areaPcsId
              dateModified
              children {
                id
                name
                type
                isActive
                floorLevel
                siteId
                disciplineId
                trafficSafety
                areaPcsId
                dateModified
                lowerGridLine
                upperGridLine
                children {
                  id
                  name
                  type
                  isActive
                  floorLevel
                  siteId
                  disciplineId
                  trafficSafety
                  areaPcsId
                  dateModified
                }
              }
            }
          }
        }
      }
    `,
  );

  return {
    query,
    variables: {
      site: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      discipline: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        null,
        JSON.parse(getValueFromLocalStorage('oldSiteId')),
        JSON.parse(getValueFromLocalStorage('oldDisciplineId')),
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
        true,
      ),
    },
  };
};
